import { makeStyles, createStyles } from "@mui/styles"

export const useNavTheme = makeStyles((theme?: any) => createStyles(
{
	MobileNavDrawer: {
		zIndex: 9000000,
		'&.MuiDrawer-paper': {
			backgroundColor: '#272b47 !important',
			color: 'yellow !important',
		},
	}
}))